import { ContextMenu } from "@skilitics/designer-ui-components";
import type { FormatMessages } from "@skilitics/localization";
import { useFormatMessage } from "@skilitics/localization";

import type { DesignerNode } from "../../types";
import { BrowseTemplatesAndReplaceMenuItem } from "./menu-items/BrowseTemplatesAndReplaceMenuItem";
import { CopyMenuItem } from "./menu-items/CopyMenuItem";
import { PasteReplaceMenuItem } from "./menu-items/PasteReplaceMenuItem";
import { SaveTemplateMenuItem } from "./menu-items/SaveTemplateMenuItem";

interface Props {
  node: DesignerNode;
}

export const NodeTreeEntryActionsMenu = ({ node }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);
  return (
    <ContextMenu data-test="node-tree-entry-context-menu">
      <CopyMenuItem node={node}>{formatMessage("copyLabel", { type: node.role })}</CopyMenuItem>
      <PasteReplaceMenuItem node={node}>{formatMessage("pasteReplaceLabel", { type: node.role })}</PasteReplaceMenuItem>
      <SaveTemplateMenuItem node={node}>{formatMessage("saveTemplateLabel", { type: node.role })}</SaveTemplateMenuItem>
      <BrowseTemplatesAndReplaceMenuItem node={node}>
        {formatMessage("browseTemplatesAndReplaceLabel", { type: node.role })}
      </BrowseTemplatesAndReplaceMenuItem>
    </ContextMenu>
  );
};

const formatStrings = {
  copyLabel: {
    en: "Copy {type}",
  },
  pasteReplaceLabel: {
    en: "Paste to Replace {type}",
  },
  saveTemplateLabel: {
    en: "Save {type} Template",
  },
  browseTemplatesAndReplaceLabel: {
    en: "Browse {type} Templates and Replace",
  },
} satisfies FormatMessages;
